<template>
  <div class="pa-5">
    <!-- <v-skeleton-loader
      class="mx-auto"
      v-if="!announcements"
      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
    ></v-skeleton-loader> -->
    <v-card shaped class="elevation-10">
      <v-card-title>
        <div>ประกาศรับสมัครงาน</div>
        <v-spacer></v-spacer>
        <v-btn color="success" to="/job/new">สร้างประกาศ</v-btn>
      </v-card-title>

      <v-card-text v-if="announcement">
        <v-expansion-panels>
          <v-expansion-panel
            v-for="item in announcement.data"
            :key="item.id"
          >
            <v-expansion-panel-header>
              <span>
                <v-chip small :color="item.status == 1 ? 'success' : ''">
                  {{ item.status == 1 ? 'เปิดรับสมัคร' : 'ปิดรับสมัคร' }}
                </v-chip>
                {{ `${item.no} ${item.title}` }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="pb-5">
                <v-subheader class="px-0">ตำแหน่ง</v-subheader>
                <ol>
                  <li v-for="job in item.jobs" :key="job.id">{{ `${job.position_work.name} จำนวน ${job.qty} อัตรา` }}</li>
                </ol>
              </div>

              <div class="pb-5" v-if="item.results && item.results.length > 0">
                <v-subheader class="px-0">ประกาศ</v-subheader>
                <ol>
                  <li v-for="result in item.results" :key="result.id">
                    <a :href="`https://srru.ac.th/personnel/storage/jobs/announcements/${result.file_path}`" target="_blank">
                      {{ `${result.no} ${result.title}` }}
                    </a>
                    <v-btn class="mx-1" color="info" x-small tile @click="edit_result(result)">แก้ไข</v-btn>
                    <v-btn color="error" x-small tile @click="delete_result(result)">ลบ</v-btn>
                  </li>
                </ol>
              </div>

              <v-row>
                <v-btn
                  class="mr-1"
                  color="success"
                  small
                  tile
                  :href="`https://srru.ac.th/personnel/storage/jobs/announcements/${item.file_path}`" target="_blank"
                >
                  <v-icon>mdi-download</v-icon>
                  ดาวน์โหลดเอกสาร
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  class="mr-1"
                  color="primary"
                  small
                  tile
                  @click="change_status(item)"
                >
                  <v-icon small>mdi-list-status</v-icon>
                  เปลี่ยนสถานะ
                </v-btn>
                <v-btn
                  class="mr-1"
                  color="warning"
                  small
                  tile
                  @click="create_result(item.id)"
                >
                  <v-icon small>mdi-bullhorn</v-icon>
                  ประกาศ
                </v-btn>
                <v-btn
                  class="mr-1"
                  color="info"
                  small
                  tile
                  :to="`/job/${item.id}/edit`"
                >
                  <v-icon small>mdi-pencil</v-icon>
                  แก้ไข
                </v-btn>
                <v-btn
                  class="mr-1"
                  color="error"
                  small
                  tile
                  @click="delete_announcement(item)"
                >
                  <v-icon small>mdi-delete</v-icon>
                  ลบ
                </v-btn>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>

    <ResultFormDialog
      v-if="result_form_dialog"
      :form_type="result_form_type"
      :form="result_form"
      :announcement_types="announcement_types"
      :dialog.sync="result_form_dialog"
      @submit="submit_result"
    />
    <ResultDeleteDialog
      @submit="submit_delete_result"
      :dialog.sync="result_delete_dialog"
      :title="result_delete_selected_title"
    />
    <AnnouncementDeleteDialog
      @submit="submit_delete_announcement"
      :dialog.sync="announcement_delete_dialog"
    />
    <ChangeStatusDialog
      v-if="change_status_dialog"
      :form="change_status_form"
      :dialog.sync="change_status_dialog"
      @submit="submit_change_status"
    />
  </div>
</template>

<script>
import ResultFormDialog from './ResultFormDialog';
import ResultDeleteDialog from './ResultDeleteDialog';
import AnnouncementDeleteDialog from './AnnouncementDeleteDialog';
import ChangeStatusDialog from './ChangeStatusDialog';

export default {
  components: {
    ResultFormDialog,
    ResultDeleteDialog,
    AnnouncementDeleteDialog,
    ChangeStatusDialog
  },
  data: () => ({
    result_form_dialog: false,
    result_delete_dialog: false,
    result_delete_selected: '',
    result_delete_selected_title: '',
    announcement_delete_dialog: false,
    announcement_delete_selected: '',
    result_form: null,
    announcement: null,
    result_form_type: '',
    change_status_dialog: false,
    change_status_form: {
      announcement_id: '',
      status: ''
    }
  }),
  computed: {
    announcement_types() { return this.$store.state.announcement_types }
  },
  created() {
    this.get_data();
  },
  methods: {
    get_data() {
      this.$store.dispatch('job/get_all').then(data => this.announcement = data);
    },
    create_result(id) {
      this.result_form_type = 'NEW';
      this.result_form = {
        announcement_id: id,
        no: '',
        title: '',
        type: '',
        file: null
      };
      this.result_form_dialog = true;
    },
    edit_result(item) {
      this.result_form_type = 'EDIT';
      this.result_form = {
        id: item.id,
        announcement_id: item.announcement_id,
        no: item.no,
        title: item.title,
        type: item.type,
        file: null
      };
      this.result_form_dialog = true;
    },
    delete_result(result) {
      this.result_delete_dialog = true;
      this.result_delete_selected = result.id;
      this.result_delete_selected_title = `${result.no} ${result.title}`;
    },
    delete_announcement(announcement) {
      this.announcement_delete_dialog = true;
      this.announcement_delete_selected = announcement.id;
    },
    submit_delete_result() {
      this.$store.dispatch('job/delete_result', this.result_delete_selected)
        .then(res => {
          this.$store.commit('SHOW_SNACKBAR', { color: 'success', message: res.message });
          this.result_delete_dialog = false;
          this.get_data();
        })
        .catch(() => {
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        });
    },
    submit_delete_announcement() {
      this.$store.dispatch('job/delete_announcement', this.announcement_delete_selected)
        .then(res => {
          this.$store.commit('SHOW_SNACKBAR', { color: 'success', message: res.message });
          this.announcement_delete_dialog = false;
          this.get_data();
        })
        .catch(() => {
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        });
    },
    submit_result(form) {
      this.$store.dispatch(this.result_form_type === 'NEW' ? 'job/store_result': 'job/update_result', this.create_form_data(form))
        .then(res => {
          this.$store.commit('SHOW_SNACKBAR', { color: 'success', message: res.message });
          this.result_form_dialog = false;
          this.get_data();
        })
        .catch(() => {
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        });
    },
    change_status(item) {
      this.change_status_form.announcement_id = item.id;
      this.change_status_form.status = item.status;
      this.change_status_dialog = true;
    },
    submit_change_status() {
      this.$store.dispatch('job/change_status', this.change_status_form)
        .then(res => {
          this.$store.commit('SHOW_SNACKBAR', { color: 'success', message: res.message });
          this.change_status_dialog = false;
          this.get_data();
        })
        .catch(() => {
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        });
    },
    create_form_data(form) {
      const form_data = new FormData;

      if(form.id) {
        form_data.append('id', form.id);
      }

      form_data.append('no', form.no);
      form_data.append('announcement_id', form.announcement_id);
      form_data.append('type', form.type);
      form_data.append('title', form.title);
      form_data.append('file', form.file);

      return form_data;
    }
  }
}
</script>